import type { PropsWithChildren } from 'react';

import { AppBar } from '../../components/app-bar';
import { Toolbar } from '../../components/toolbar';

/** @experimental In active development. Avoid using until further notice. */
export const DashboardAppBar = ({ children }: PropsWithChildren) => {
  return (
    <AppBar
      color="default"
      elevation={4}
      sx={{
        backgroundImage: 'none', // remove overlay
        displayPrint: 'none',
        position: 'relative',
      }}
    >
      <Toolbar>{children}</Toolbar>
    </AppBar>
  );
};
